import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Logger } from '@core/services';
import { iAdminService } from 'src/app/core/services/iAdmin.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export abstract class BaseHttpService {
  protected readonly iAdminService = inject(iAdminService);
  protected readonly http = inject(HttpClient);
  protected readonly logger = inject(Logger);

  protected abstract endPoint: string;
  protected readonly environment = environment;
  protected baseURL = `${this.environment.apiGatewayBaseUrl}/api/v1`;
  private iCourrierBaseURL = this.environment.apiICourrierBaseUrl;
  private iAdminBaseURL = `${this.environment.apiIAdminBaseUrl}/api/v1`;

  protected buildURL(options?: {
    apiScope?: 'iDélibé' | 'iCourrier' | 'iAdmin';
    overrideEndPoint?: string;
    idOrSubEndpoint?: number | string;
  }): string {
    const { idOrSubEndpoint, apiScope = 'iDélibé', overrideEndPoint } = options ?? {};
    const baseURL =
      apiScope === 'iDélibé' ? this.baseURL : apiScope === 'iCourrier' ? this.iCourrierBaseURL : this.iAdminBaseURL;

    return idOrSubEndpoint
      ? `${baseURL}/${overrideEndPoint ?? this.endPoint}/${idOrSubEndpoint}`
      : `${baseURL}/${overrideEndPoint ?? this.endPoint}`;
  }

  protected setBaseURL(url: string): void {
    this.baseURL = url;
  }

  protected resetBaseURL(): void {
    this.baseURL = `${this.environment.apiGatewayBaseUrl}/api/v1`;
    this.iCourrierBaseURL = this.environment.apiICourrierBaseUrl;
  }
}
